export enum DaysAllowedTypeEnum {
  /**
   * Tots els dies
   */
  CALENDAR_DAYS = 'calendar_days',

  /**
   * Tots els dies menys els dies que son festa i els dies que son cap de setmana
   */
  WORKING_DAYS = 'working_days',

  /**
   * Tots els dies menys els dies que son festa
   */
  BUSINESS_DAYS = 'business_days',
}
